import React from 'react';
import moment from 'moment';
import classnames from 'classnames';
import { isPremium } from '../services/Wix';
import { getOpeningState } from '../services/openingHours';
import { createBadgeTextLines } from '../services/badgeText';

export default function createBadgeContainer(WrappedComponent) {
  return class extends React.Component {
    constructor(props) {
      super(props);

      this.state = {
        currentDate: new Date(),
        hide: false
      };
    }

    componentDidMount() {
      const { updateInterval = 1000 } = this.props;

      this.interval = setInterval(
        () => {
          this.setState(() => ({
            currentDate: new Date()
          }));
        },
        updateInterval
      );
    }

    componentWillUnmount() {
      if (this.interval) {
        clearInterval(this.interval);
      }
    }

    componentWillReceiveProps() {
      // chrome keeps on animating the sign, even if the animation setting
      // was disabled. This code here is supposed to be a workaround for that problem.

      const isChrome = window.navigator.userAgent.indexOf('Chrome') > -1;

      if (
        !isChrome || !this.props.enableChromeRenderingHack || this.state.hide
      ) {
        return;
      }
      this.setState({ hide: true });

      setTimeout(
        () => {
          this.setState({ hide: false });
        },
        0
      );
    }

    render() {
      const { styles, data, className, languageSpecificSettings } = this.props;
      const { hide } = this.state;

      if (!styles || !data || hide) {
        return null;
      }

      const lang = styles.language.value;
      const zoneInfo = moment.tz.zone(styles.timezone);

      const openingState = getOpeningState(
        zoneInfo,
        data.openingHoursByDay,
        isPremium() ? data.specialOpeningHours : []
      );

      const showFreePlanClaim = data.pricingSchema === 2 && !isPremium();
      const isOpen = openingState.status === 'OPENED';
      const lines = createBadgeTextLines(
        openingState,
        zoneInfo,
        lang,
        styles.timeFormat.value,
        styles.dateFormat.value
      );
      let languageSettings = {};

      if (languageSpecificSettings && languageSpecificSettings[lang]) {
        languageSettings = languageSpecificSettings[lang];
      }

      return (
        <WrappedComponent
          {...this.props}
          {...this.state}
          {...lines}
          className={classnames(className, {
            'Badge--small': languageSettings.small
          })}
          isOpen={isOpen}
          showFreePlanClaim={showFreePlanClaim}
          languageSettings={languageSettings}
        />
      );
    }
  };
}



// WEBPACK FOOTER //
// ./src/commons/badges/createBadgeContainer.jsx